import {
  getFormData,
  resetFormErrors,
  resetFormValues,
  showFormErrors
} from '../../utils/form';
import * as notification from '../../components/notifications';

let createEmployerUserInvitationModal;
let updateEmployerUserInvitationModal;
let employerUserInvitationIdForDeletion;
let createEmployerUserInvitationForm;
let updateEmployerUserInvitationForm;
let selectedUpdateAction;

const initPage = () => {
  createEmployerUserInvitationModal = $("#create-employer-user-invitation-modal");
  updateEmployerUserInvitationModal = $("#update-employer-user-invitation-modal");
  createEmployerUserInvitationForm = $("#create-employer-user-invitation-form");
  updateEmployerUserInvitationForm = $("#update-employer-user-invitation-form");

  if (!createEmployerUserInvitationModal) {
    return;
  }

  $("#invite-employer-user-btn").click(function() {
    showInviteModal();
  });

  createEmployerUserInvitationModal.submit(function() {
    createEmployerUserInvitation();
    return false;
  });

  $(".edit-employer-user-invitation").click(showUpdateModal);
  updateSelectedEmployerUserInvitationModalData();

  updateEmployerUserInvitationModal.submit(function() {
    updateEmployerUserInvitation();
    return false;
  });

  $(".delete-employer-user-invitation").click(showDeleteModal);
  $("#delete-employer-user-invitation-modal .btn-modal-confirm").click(deleteEmployerUserInvitation);
  $(".re-invite-employer-user").click(resendInvitation);
};

const showInviteModal = () => {
  createEmployerUserInvitationModal.modal('show');
};

const createEmployerUserInvitation = async () => {
  const createEmployerUserInvitationForm = $("#create-employer-user-invitation-form");
  const inviteEmployerUserFormSubmitBtn = $('.btn', createEmployerUserInvitationForm);
  $(inviteEmployerUserFormSubmitBtn).loading();

  try {
    const data = getFormData(createEmployerUserInvitationForm);
    let inviteUri = '/api/account/employer_user_invitations'

    const response = await axios.post(inviteUri, data);
    resetFormErrors(createEmployerUserInvitationForm);

    createEmployerUserInvitationModal.modal('hide');
    notification.success(response.data.message);
    resetFormValues(createEmployerUserInvitationForm, ['#website_user_email']);

    window.location.reload();
  } catch (e) {
    showFormErrors(createEmployerUserInvitationForm, e.response);
  }

  $(inviteEmployerUserFormSubmitBtn).loading(false);
};

const showUpdateModal = async function (event)  {
  event.preventDefault();
  selectedUpdateAction = $(this);

  const employerUserInvitationId = selectedUpdateAction.attr('data-id');
  const employerUserInvitationEmail = selectedUpdateAction.attr('data-email');
  const employerUserInvitationRole = selectedUpdateAction.attr('data-role');

  updateEmployerUserInvitationForm.attr("data-id", employerUserInvitationId);
  $('#update_role_for_email').text(employerUserInvitationEmail);
  $('.role-help-text', updateEmployerUserInvitationForm).addClass('d-none');
  $(`.${employerUserInvitationRole}-help-text`, updateEmployerUserInvitationForm).removeClass('d-none');
  $('#update-employer-user-invitation-form select.custom-field-select').selectpicker('val', employerUserInvitationRole);

  updateEmployerUserInvitationModal.modal('show');
};

const updateSelectedEmployerUserInvitationModalData = () => {
  $(document).on('click', '#create-employer-user-invitation-form .jb-custom-select .dropdown-menu li', function () {
    const selectedRole = $('#create-employer-user-invitation-form select.custom-field-select').selectpicker('val');

    if (!selectedRole) {
      return;
    }

    $('.role-help-text', createEmployerUserInvitationForm).addClass('d-none');
    $(`.${selectedRole}-help-text`, createEmployerUserInvitationForm).removeClass('d-none');
  });

  $(document).on('click', '#update-employer-user-invitation-form .jb-custom-select .dropdown-menu li', function () {
    const selectedRole = $('#update-employer-user-invitation-form select.custom-field-select').selectpicker('val');

    if (!selectedRole) {
      return;
    }

    $('.role-help-text', updateEmployerUserInvitationForm).addClass('d-none');
    $(`.${selectedRole}-help-text`, updateEmployerUserInvitationForm).removeClass('d-none');
    selectedUpdateAction.attr('data-role', selectedRole);
  });
};

const updateEmployerUserInvitation = async () => {
  const updateEmployerUserInvitationForm = $("#update-employer-user-invitation-form");
  const employerUserInvitationId = updateEmployerUserInvitationForm.attr('data-id');

  if (!employerUserInvitationId) {
    return;
  }

  try {
    const data = getFormData(updateEmployerUserInvitationForm);
    const updateUri = '/api/account/employer_user_invitations/' + employerUserInvitationId;

    const response = await axios.patch(updateUri, data);
    resetFormErrors(updateEmployerUserInvitationForm);
    const selectedRoleText = $('#update-employer-user-invitation-form select.custom-field-select option:selected').text()

    $(`.employer-user-invitation-role-${employerUserInvitationId}`).text(selectedRoleText);

    updateEmployerUserInvitationModal.modal('hide');
    notification.success(response.data.message);
  } catch (e) {
    showFormErrors(updateEmployerUserInvitationForm, e.response);

    if (e.response.data?.message) {
      updateEmployerUserInvitationModal.modal('hide');
    }
  }
};

const showDeleteModal = function (event) {
  event.preventDefault();
  employerUserInvitationIdForDeletion = $(this).data('id');

  $('#delete-employer-user-invitation-modal').modal('show');
};

const deleteEmployerUserInvitation = async function (event) {
  try {
    if (!employerUserInvitationIdForDeletion) {
      return;
    }

    const response = await axios.delete(`/api/account/employer_user_invitations/${employerUserInvitationIdForDeletion}`);

    $('#delete-employer-user-invitation-modal').modal('hide');

    const countItemsRow = $('.employer-user-invitations-container .item-row').length;

    if (countItemsRow === 1) {
      $('.invitations-card-container').addClass('overflow-hidden');
    }

    $(`.employer-user-invitation-${employerUserInvitationIdForDeletion}`).remove();
    notification.success(response.data.message);
  } catch (e) {
    if (e.response.data?.short_message) {
      notification.danger(e.response.data.short_message);
    }
  }
};

const resendInvitation =  async function (event){
  event.preventDefault();

  try {
    const employerUserInvitationId = $(this).data('id');

    if (!employerUserInvitationId) {
      return;
    }

    const response = await axios.post(`/api/account/employer_user_invitations/${employerUserInvitationId}/resend`);
    notification.success(response.data.message);
  } catch (e) {
    if (e.response.data?.errors?.message) {
      notification.danger(e.response.data.errors.message);
    }

    if (e.response.data?.short_message) {
      notification.danger(e.response.data.short_message);
    }
  }
};

$(initPage);
